/*
 * "Become a TRADE member" section.
 * Adds UTM tags and the landing page to the apply link, so the TRADE application page in the
 * customer account can record where the applicant came from (e.g. the CEU / Cambium course).
 * Attribution is remembered for the browser session, so it survives browsing a few pages
 * before applying.
 */
(function () {
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign'];
  var STORAGE_KEY = 'fsb_pro_attribution';

  function attribution() {
    var params = new URLSearchParams(window.location.search);
    var fromUrl = {};
    KEYS.forEach(function (k) {
      if (params.get(k)) fromUrl[k] = params.get(k);
    });

    var stored = null;
    try {
      stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    } catch (e) {}

    if (Object.keys(fromUrl).length || !stored) {
      stored = Object.assign({ landing_page: window.location.pathname + window.location.search }, fromUrl);
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
      } catch (e) {}
    }
    return stored;
  }

  function decorate(root) {
    var data = attribution();
    root.querySelectorAll('a[data-pro-apply]').forEach(function (link) {
      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (e) {
        return;
      }
      Object.keys(data).forEach(function (k) {
        if (data[k]) url.searchParams.set(k, data[k]);
      });
      link.href = url.toString();
    });
  }

  decorate(document);

  // Re-run when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    decorate(event.target);
  });
})();
